import React, {useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import Input from "../../../../../../../../components/input";
import PicButton from "../../../../../../../../components/pic-button";
import Icon from "../../../../../../../../components/icon";
import {
	editCustomFieldOption as setEditCustomFieldOption,
	updateCustomFieldOption as setUpdateCustomFieldOption, deleteCustomFieldOption,
	submitCustomFieldOption as setSubmitCustomFieldOption,
	putCustomFieldOption
} from '../../../../../../../../../actions/customFieldsActions';

function CustomFieldOption ({item}) {

	const customFieldRefOption = useRef(null);

	const customFieldDetails = useSelector((state) => state.customFieldsReducer.customFieldDetails);
	const editCustomFieldOption = useSelector((state) => state.customFieldsReducer.editCustomFieldOption);
	const updateCustomFieldOption = useSelector((state) => state.customFieldsReducer.updateCustomFieldOption);
	const submitCustomFieldOption = useSelector((state) => state.customFieldsReducer.submitCustomFieldOption);

	const dispatch = useDispatch();

	const handleUpdateCustomFieldOption = () => {
		dispatch(setSubmitCustomFieldOption(item.id));
		dispatch(putCustomFieldOption(customFieldDetails.id, item.id, customFieldRefOption.current.value))
	};

	const handleDeleteCustomFieldOption = () => {
		dispatch(setSubmitCustomFieldOption(item.id));
		dispatch(deleteCustomFieldOption(customFieldDetails.id, item.name))
	};

	return (
		<li className="custom-field-option">
			{
				editCustomFieldOption === item.id
					?
					<Input
						type={"text"}
						defaultValue={item.name}
						onChange={() => dispatch(setUpdateCustomFieldOption(item.id))}
						ref={ customFieldRefOption }
					/>
					:
					<span>{item.name}</span>
			}
			{
				submitCustomFieldOption === item.id
					?
					<div className="custom-field-option__actions">
						<Icon animated={'pulse'}
						      name="spinner" className="mr-2"/>
					</div>
					:
					<div className="custom-field-option__actions">
						{
							updateCustomFieldOption === item.id
							&& <PicButton onClick={ handleUpdateCustomFieldOption }>
								<Icon name="check"/>
							</PicButton>
						}
						{
							editCustomFieldOption === item.id
								?
								<PicButton onClick={() => dispatch(setEditCustomFieldOption(""))}>
									<Icon name="times"/>
								</PicButton>
								:
								<PicButton onClick={() => dispatch(setEditCustomFieldOption(item.id))}>
									<Icon name="pencil"/>
								</PicButton>
						}
						<PicButton onClick={ handleDeleteCustomFieldOption }>
							<Icon name="trash"/>
						</PicButton>
					</div>
			}
		</li>
	)
}

export default CustomFieldOption;
